<template>
    <div class="payment-fields shipment-card-form">
        <template>
            <v-text-field
                v-model="localData.amount"
                :rules="[valid.amount]"
                light
                outlined
                dense
                type="number"
                name="amount"
                :label="$t('pages.payments.enterAmount')"
                class="payment-field"
                @input="emitUpdate"
            ></v-text-field>
        </template>

        <template>
            <v-text-field
                v-model="localData.due_date"
                :rules="[valid.due_date]"
                light
                outlined
                dense
                type="date"
                name="due_date"
                :label="$t('pages.payments.dueDate')"
                class="payment-field"
                @input="emitUpdate"
            ></v-text-field>
        </template>

        <template>
            <v-text-field
                v-model="localData.bank_account_number"
                :rules="[valid.bank_account_number]"
                light
                outlined
                dense
                type="text"
                name="bank_account_number"
                :label="$t('pages.payments.enterBankAccountNumber')"
                class="payment-field"
                maxlength="4"
                @input="emitUpdate"
            ></v-text-field>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        amount: {
            type: [String, Number],
            default: null,
        },
        due_date: {
            type: String,
            default: '',
        },
        bank_account_number: {
            type: [String, Number],
            default: null,
        },
        local_id: {
            type: [String, Number],
            default: null,
        },
        payment_type: {
            type: Number,
            default: null,
        },
        hideFields: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update-payment'],

    data() {
        const requiredField = (v) =>
            !!v || this.$t('pages.payments.fieldIsRequired')

        return {
            localData: {
                amount: this.amount || null,
                due_date:
                    this.due_date || new Date().toISOString().slice(0, 10),
                bank_account_number: this.bank_account_number || null,
                local_id: this.local_id || null,
                payment_type: this.payment_type || null,
                quantity: 1,
            },
            valid: {
                amount: requiredField,
                due_date: requiredField,
                bank_account_number: requiredField,
            },
        }
    },
    watch: {
        due_date(newValue) {
            this.localData.due_date = newValue
        },
        amount(newValue) {
            this.localData.amount = newValue
        },
        bank_account_number(newValue) {
            this.localData.bank_account_number = newValue
        },
    },
    methods: {
        emitUpdate() {
            this.$emit('update-payment', this.localData)
        },
        formatDate(date) {
            if (!date) return ''

            if (typeof date === 'string' && date.includes('-')) {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }

            return date
        },
    },
}
</script>

<style lang="scss">
.shipment-card-form {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0;
    width: 100%;
}

.payment-field {
    max-width: 100% !important;
    min-width: 100%;
}

.payment-field__block {
    display: flex;
    margin-bottom: 28px;
}

.small {
    font-size: 12px;
    color: #ababab;
    text-wrap: nowrap;
}
</style>

